export default __webpack_public_path__ + "static/media/CloseCircle.bc8b24ae.svg";